import "./App.css";
import "./css/colors.css";
import "./css/fonts.css";
import "./css/components.css";
import "./css/modal.css";
import "./css/transitions.css";

import React from "react";
import { createBrowserHistory } from "history";
import { Suspense } from "react";
import { Provider } from "react-redux";
import { Spinner } from "react-bootstrap";
import { store } from "./Reducer";
import { Route, BrowserRouter, Routes } from "react-router-dom";
import { WebRoutes } from "./Constants";
import { PrivateRoute, ErrorToast } from "./Components";
import {
  InboxPage,
  StudentHomePage,
  UserHomePage,
  StatsOverviewPage,
  BookOverviewPage,
  BarcodeOverviewPage,
  StudentOverviewPage,
  ImportOverviewPage,
  KeyValueAdministrationPage,
  LanguagesAdministrationPage,
  LogsAdministrationPage,
  UsersAdministrationPage,
  SchoolOverviewPage,
  SchoolReturnPage,
  SchoolHomePage,
  StudentProfilePage,
  UserProfilePage,
  SchoolProfilePage,
} from "./Pages/Logged";

import { EntryPage, UserLoginPage, StudentLoginPage } from "./Pages/NotLogged";
import Logout from "./Pages/NotLogged/Logout/Logout";
import { NoRolePage } from "./Pages/Logged/Common/NoRolePage/NoRolePage";
import { ChangePassword } from "./Pages/Logged/Common/ChangePassword/ChangePassword";
import { SummaryBooks } from "./Pages/Logged/Common/SummaryBooks/SummaryBooks";
import { UserNotEnabled } from "./Pages/Logged/Common/UserNotEnabled/UserNotEnabled";
import { IddinkSchoolManagerHome } from "./Pages/Logged/User/IddinkSchoolManagerHome/IddinkSchoolManagerHome";
import { IddinkEmployeeHome } from "./Pages/Logged/User/IddinkEmployeeHome/IddinkEmployeeHome";
import { SchoolReturns } from "./Pages/Logged/SchoolBookManager/SchoolReturns/SchoolReturns";
import { SchoolPackageReturns } from "./Pages/Logged/SchoolBookManager/SchoolPackageReturns/SchoolPackageReturns";
import { PackageReturns } from "./Pages/Logged/SchoolBookManager/PackageReturns/PackageReturns";
import { SummarySchool } from "./Pages/Logged/SchoolBookManager/SummarySchool/SummarySchool";
import { SchoolBookPurchase } from "./Pages/Logged/SchoolBookManager/SchoolBookPurchase/SchoolBookPurchase";
import { SummaryPurchaseSchool } from "./Pages/Logged/SchoolBookManager/SummaryPurchaseSchool/SummaryPurchaseSchool";
import { ConfigProvider } from "./config/ConfigProvider";
import { LogisticsPackage } from "./Pages/Logged/User/IddinkEmployeeHome/LogisticsPackage/LogisticsPackage";
import { SchoolBookPurchaseQuantity } from "./Pages/Logged/SchoolBookManager/SchoolBookPurchaseQuantity/SchoolBookPurchaseQuantity";
import { LogisticsProvider } from "./Contexts/Logistics/LogisticsContext";
import SchoolManagementPage from "@pages/Logged/School/SchoolManagement";
import SchoolManageDeadlinesPage from "@pages/Logged/School/SchoolManageDeadlines";
import { PreregistrationDasbhboard } from "@pages/Logged/PreregistrationSchools/Dashboard/PreregistrationDashboard";
import PreregistrationSchoolPage from "@pages/Logged/PreregistrationSchools/PreregistrationSchoolsView";
import { PreregistrationBooks } from "@pages/Logged/PreregistrationSchools/PreregistrationBooks/PreregistrationBooks";


export default function App() {
  return (
    <Provider store={store}>
      <Suspense fallback={<Spinner />}>
        <link
          href="https://fonts.googleapis.com/icon?family=Material+Icons+Round"
          rel="stylesheet"
        />
        <Components />
      </Suspense>
    </Provider>
  );
}
const history = createBrowserHistory();

function Components() {
  return (
    <ConfigProvider>
      <LogisticsProvider>
        <ErrorToast />
        <BrowserRouter history={history}>
          <Routes>
            {/* NOT LOGGED */}
            <Route path={WebRoutes.WrongPage} element={<EntryPage />} />
            <Route path={WebRoutes.Logout} element={<Logout />} />
            <Route path={WebRoutes.EntryPage} element={<EntryPage />} />
            <Route
              path={WebRoutes.StudentLoginPage}
              element={<StudentLoginPage />}
            />
            <Route path={WebRoutes.UserLoginPage} element={<UserLoginPage />} />
            {/* LOGGED COMMON*/}
            <Route
              path={WebRoutes.ChangePasswordPage}
              element={
                <PrivateRoute>
                  <ChangePassword />
                </PrivateRoute>
              }
            />
            <Route
              path={WebRoutes.NoRolePage}
              element={
                <PrivateRoute>
                  <NoRolePage />
                </PrivateRoute>
              }
            />
            <Route
              path={WebRoutes.InboxPage}
              element={
                <PrivateRoute>
                  <InboxPage />
                </PrivateRoute>
              }
            />
            <Route
              path={WebRoutes.UserNotEnabled}
              element={
                <PrivateRoute>
                  <UserNotEnabled />
                </PrivateRoute>
              }
            />
            {/* LOGGED STUDENT*/}
            <Route path={WebRoutes.SummaryBooks} element={<SummaryBooks />} />
            <Route
              path={WebRoutes.StudentHomePage}
              element={
                <PrivateRoute>
                  <StudentHomePage />
                </PrivateRoute>
              }
            />
            <Route
              path={WebRoutes.StudentProfilePage}
              element={
                <PrivateRoute>
                  <StudentProfilePage />
                </PrivateRoute>
              }
            />
            {/* LOGGED SCHOOL*/}
            <Route
              path={WebRoutes.SchoolHomePage}
              element={
                <PrivateRoute>
                  <SchoolHomePage />
                </PrivateRoute>
              }
            />
            <Route
              path={WebRoutes.SchoolReturnPage}
              element={
                <PrivateRoute>
                  <SchoolReturnPage />
                </PrivateRoute>
              }
            />
            <Route
              path={WebRoutes.SchoolProfilePage}
              element={
                <PrivateRoute>
                  <SchoolProfilePage />
                </PrivateRoute>
              }
            />
            <Route
              path={WebRoutes.SchoolManagementPage}
              element={
                <PrivateRoute>
                  <SchoolManagementPage />
                </PrivateRoute>
              }
            />
            <Route
              path={WebRoutes.SchoolDeadlineManagementPage}
              element={
                <PrivateRoute>
                  <SchoolManageDeadlinesPage />
                </PrivateRoute>
              }
            />
            {/* LOGGED ADMIN*/}
            <Route
              path={WebRoutes.UserHomePage}
              element={
                <PrivateRoute>
                  <UserHomePage />
                </PrivateRoute>
              }
            />
            <Route
              path={WebRoutes.UserProfilePage}
              element={
                <PrivateRoute>
                  <UserProfilePage />
                </PrivateRoute>
              }
            />
            <Route
              path={WebRoutes.StatsOverviewPage}
              element={
                <PrivateRoute>
                  <StatsOverviewPage />
                </PrivateRoute>
              }
            />
            <Route
              path={WebRoutes.BookOverviewPage}
              element={
                <PrivateRoute>
                  <BookOverviewPage />
                </PrivateRoute>
              }
            />
            <Route
              path={WebRoutes.StudentOverviewPage}
              element={
                <PrivateRoute>
                  <StudentOverviewPage />
                </PrivateRoute>
              }
            />
            <Route
              path={WebRoutes.BarcodeOverviewPage}
              element={
                <PrivateRoute>
                  <BarcodeOverviewPage />
                </PrivateRoute>
              }
            />
            <Route
              path={WebRoutes.SchoolOverviewPage}
              element={
                <PrivateRoute>
                  <SchoolOverviewPage />
                </PrivateRoute>
              }
            />
             <Route
              path={WebRoutes.PreregistrationDashboard}
              element={
                <PrivateRoute>
                  <PreregistrationDasbhboard />
                </PrivateRoute>
              }
            />
            <Route
              path={WebRoutes.ImportOverviewPage}
              element={
                <PrivateRoute>
                  <ImportOverviewPage />
                </PrivateRoute>
              }
            />
            <Route
              path={WebRoutes.KeyValueAdministrationPage}
              element={
                <PrivateRoute>
                  <KeyValueAdministrationPage />
                </PrivateRoute>
              }
            />
            <Route
              path={WebRoutes.LanguagesAdministrationPage}
              element={
                <PrivateRoute>
                  <LanguagesAdministrationPage />
                </PrivateRoute>
              }
            />
            <Route
              path={WebRoutes.LogsAdministrationPage}
              element={
                <PrivateRoute>
                  <LogsAdministrationPage />
                </PrivateRoute>
              }
            />
            <Route
              path={WebRoutes.UsersAdministrationPage}
              element={
                <PrivateRoute>
                  <UsersAdministrationPage />
                </PrivateRoute>
              }
            />
              <Route
              path={WebRoutes.PreregistrationSchools}
              element={
                <PrivateRoute>
                  <PreregistrationSchoolPage />
                </PrivateRoute>
              }
            />
               <Route
              path={WebRoutes.PreregistrationBooks}
              element={
                <PrivateRoute>
                  <PreregistrationBooks />
                </PrivateRoute>
              }
            />
            {/* LOGGED IDDINK EMPLOYEE*/}
            <Route
              path={WebRoutes.IddinkEmployeeHome}
              element={
                <PrivateRoute>
                  <IddinkEmployeeHome />
                </PrivateRoute>
              }
            />
            <Route
              path={WebRoutes.LogisticsPackage}
              element={
                <PrivateRoute>
                  <LogisticsPackage />
                </PrivateRoute>
              }
            />
            {/* LOGGED IDDINK SCHOOL MANAGER*/}
            <Route
              path={WebRoutes.IddinkSchoolManagerHome}
              element={
                <PrivateRoute>
                  <IddinkSchoolManagerHome />
                </PrivateRoute>
              }
            />
            {/* LOGGED SCHOOL BOOK MANAGER*/}
            <Route
              path={WebRoutes.SchoolBookPurchase}
              element={
                <PrivateRoute>
                  <SchoolBookPurchase />
                </PrivateRoute>
              }
            />

            <Route
              path={WebRoutes.SchoolBookPurchaseQuantity}
              element={
                <PrivateRoute>
                  <SchoolBookPurchaseQuantity />
                </PrivateRoute>
              }
            />
            <Route
              path={WebRoutes.SchoolBookSummaryPurchase}
              element={<SummaryPurchaseSchool />}
            />
            <Route
              path={WebRoutes.SchoolReturns}
              element={
                <PrivateRoute>
                  <SchoolReturns />
                </PrivateRoute>
              }
            />
            <Route
              path={WebRoutes.SchoolPackageReturns}
              element={
                <PrivateRoute>
                  <SchoolPackageReturns />
                </PrivateRoute>
              }
            />
            <Route
              path={WebRoutes.PackageReturns}
              element={
                <PrivateRoute>
                  <PackageReturns />
                </PrivateRoute>
              }
            />
            <Route path={WebRoutes.SchoolSummary} element={<SummarySchool />} />
            {/* LOGGED ADMIN USERS*/}
            <Route
              path={WebRoutes.UsersAdministrationPage}
              element={
                <PrivateRoute>
                  <UsersAdministrationPage />
                </PrivateRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </LogisticsProvider>
    </ConfigProvider>
  );
}
